import { useQuery } from '@apollo/client';
import { customersApi } from '../api';

export function useGeneralTabDataFetch(customerAccountId: string) {
  const { data: customerDetailsData, loading: isCustomerDetailsLoading } = useQuery(customersApi.getCustomerDetails, {
    variables: {
      customerAccountId,
    },
  });

  const { data: customerContactsData, loading: isCustomerContactsLoading } = useQuery(
    customersApi.getCustomerContacts,
    {
      variables: {
        customerAccountId,
      },
    }
  );

  const { data: customerOpportunitiesData, loading: isCustomerOpportunitiesLoading } = useQuery(
    customersApi.getCustomerOpportunities,
    {
      variables: {
        customerAccountId,
      },
    }
  );

  const { data: customerProposalsData, loading: isCustomerProposalsLoading } = useQuery(
    customersApi.getCustomerProposals,
    {
      variables: {
        customerAccountId,
      },
    }
  );

  return {
    isLoading:
      isCustomerDetailsLoading ||
      isCustomerContactsLoading ||
      isCustomerOpportunitiesLoading ||
      isCustomerProposalsLoading,
    customerDetails: customerDetailsData?.customer?.customerDetails?.entity,
    customerContacts: customerContactsData?.customer?.customerContacts?.list,
    customerOpportunities: customerOpportunitiesData?.customer?.customerOpportunities?.list,
    customerProposals: customerProposalsData?.customer?.customerProposals?.list,
  };
}
